import { useState } from 'react';
import { Language } from '@breathelife/types';
import { AgreeFieldBlueprint, FieldBlueprint, FieldTypes } from '@zinnia/form-engine-sdk';

import {
  FieldDataFromBlueprint,
  FieldDataHookReturnValue,
  LanguageDependentSetter,
  useCastBlueprintToFieldType,
} from '../../Helpers/helperTypes';

export type AgreeFieldData = FieldDataFromBlueprint<
  AgreeFieldBlueprint,
  'confirmedLabel' | 'modalText' | 'modalHeader'
>;

export type AgreeFieldSetters = {
  setModalHeader: LanguageDependentSetter;
  setModalText: LanguageDependentSetter;
  setConfirmedLabel: LanguageDependentSetter;
};

export function useAgreeFieldData({
  initialData,
}: {
  initialData?: Partial<FieldBlueprint>;
}): FieldDataHookReturnValue<AgreeFieldData, AgreeFieldSetters> {
  const initialDataAsAgreeField = useCastBlueprintToFieldType<AgreeFieldBlueprint>(FieldTypes.agree, initialData);

  const [modalHeaderFr, setModalHeaderFr] = useState<AgreeFieldData['modalHeader']['fr']>(
    initialDataAsAgreeField?.modalHeader?.fr || '',
  );
  const [modalHeaderEn, setModalHeaderEn] = useState<AgreeFieldData['modalHeader']['en']>(
    initialDataAsAgreeField?.modalHeader?.en || '',
  );
  const [modalTextFr, setModalTextFr] = useState<AgreeFieldData['modalText']['fr']>(
    initialDataAsAgreeField?.modalText?.fr || '',
  );
  const [modalTextEn, setModalTextEn] = useState<AgreeFieldData['modalText']['en']>(
    initialDataAsAgreeField?.modalText?.en || '',
  );
  const [confirmedLabelFr, setConfirmedLabelFr] = useState<AgreeFieldData['confirmedLabel']['fr']>(
    initialDataAsAgreeField?.confirmedLabel?.en || '',
  );
  const [confirmedLabelEn, setConfirmedLabelEn] = useState<AgreeFieldData['confirmedLabel']['en']>(
    initialDataAsAgreeField?.confirmedLabel?.en || '',
  );

  const setModalHeader: LanguageDependentSetter = (language, value) => {
    switch (language) {
      case Language.en:
        setModalHeaderEn(value);
        break;
      case Language.fr:
        setModalHeaderFr(value);
        break;
    }
  };

  const setModalText: LanguageDependentSetter = (language, value) => {
    switch (language) {
      case Language.en:
        setModalTextEn(value);
        break;
      case Language.fr:
        setModalTextFr(value);
        break;
    }
  };

  const setConfirmedLabel: LanguageDependentSetter = (language, value) => {
    switch (language) {
      case Language.en:
        setConfirmedLabelEn(value);
        break;
      case Language.fr:
        setConfirmedLabelFr(value);
        break;
    }
  };

  return {
    data: {
      modalHeader: {
        en: modalHeaderEn,
        fr: modalHeaderFr,
      },
      modalText: {
        en: modalTextEn,
        fr: modalTextFr,
      },
      confirmedLabel: {
        en: confirmedLabelEn,
        fr: confirmedLabelFr,
      },
    },
    setters: {
      setModalHeader,
      setModalText,
      setConfirmedLabel,
    },
    clearData: () => {},
  };
}
